import React, { useState, useContext, useReducer, useEffect } from 'react';
import { List, Page } from '../../components';
import { GoodsSelect, GoodsPriceEdit, GoodsPriceBatchEdit } from '..';
import {
  getGoodsList,
  getGoodsSpecPriceList,
  insertGoodsPrice,
  updateGoodsPrice,
  deleteGoodsPrice,
  insertGoods,
  deleteGoods,
  checkCanDeleteGoods,
  getGoodsListByDatetime
} from '../../services/Supplier';
import moment from 'moment';
import {
  Row, Col,
  Divider,
  Button,
  Tabs,
  Select,
  Modal,
  message
} from 'antd';
import {
  CloseOutlined,
  DollarOutlined,
  PlusOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { MasterContext } from '../../App';
import './style';

const { TabPane } = Tabs;
export default React.forwardRef((props, ref) => {
  const { supplier, onCloseCallback } = props;
  const { currency, currentUser, authorities, goods_category } = useContext(MasterContext);
  const [isShowGoodsSelect, setShowGoodsSelect] = useState(false);
  const [isShowPriceEdit, setShowPriceEdit] = useState(false);
  const [isShowBatchPriceEdit, setShowBatchPriceEdit] = useState(false);
  const [isShowPriceNew, setShowPriceNew] = useState(false);
  const [goodsList, setGoodsList] = useState([]);
  const [goodsPriceList, setGoodsPriceList] = useState([]);
  const [selectedGoodsIndex, setSelectedGoodsIndex] = useState(-1);
  const [selectedPriceIndex, setSelectedPriceIndex] = useState(-1);
  const [filterGoodsId, setFilterGoodsId] = useState(undefined);

  let goodsListItem = [];
  if (filterGoodsId) {
    goodsListItem = goodsList.filter(x => x.goods_id === filterGoodsId).map((item, index) => {
      return Object.assign({
        editable: false,
        deletable: authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1
      }, item)
    });
  } else {
    goodsListItem = goodsList.map((item, index) => {
      return Object.assign({
        editable: false,
        deletable: authorities.find(x => x === 'create_buyer' || x === 'edit_buyer') || currentUser.category_id === 1
      }, item)
    });
  }

  const selectedGoods = goodsListItem[selectedGoodsIndex] || {};
  const selectedGoodsPrice = goodsPriceList[selectedPriceIndex] || {};

  const getSupplierGoodsListAndPrice = (dt) => {
    return getGoodsListByDatetime(supplier.id, dt);
  }

  const onClose = () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const reloadGoods = () => {
    var p1 = new Promise((resolve, reject) => {
      getGoodsList(supplier.id).then(goods => {
        setGoodsList(goods);
        resolve(true);
      });
    });
    return Promise.all([p1]).then(values => {
      //setLoadding(false);
    });
  }

  const reloadGoodsPrice = () => {
    var p1 = new Promise((resolve, reject) => {
      getGoodsSpecPriceList(supplier.id, selectedGoods.goods_id, selectedGoods.goods_spec_id).then(data => {
        setGoodsPriceList(data);
        resolve(true);
      });
    });
    return Promise.all([p1]).then(values => {
      //setLoadding(false);
    });
  }

  useEffect(() => {
    getGoodsList(supplier.id).then(goods => {
      setGoodsList(goods);
      if (goods.length > 0) {
        setSelectedGoodsIndex(0);
      }
    });
  }, []);

  useEffect(() => {
    if (selectedGoodsIndex > -1) {
      getGoodsSpecPriceList(supplier.id, selectedGoods.goods_id, selectedGoods.goods_spec_id).then((data) => {
        setGoodsPriceList(data);
      })
    } else {
      setGoodsPriceList([]);
    }
  }, [selectedGoodsIndex]);

  const onGoodsSelect = (goods) => {
    if (goods.length === 0) {
      setShowGoodsSelect(false);
      return;
    }
    try {
      const key = 'create_supplier_goods';
      console.log('onSave:', goods);
      message.loading({ content: `正在新建客户产品 [${supplier.name_cn}]...`, key });
      insertGoods(supplier.id, goods).then(() =>
        getGoodsList(supplier.id).then(goods => {
          setGoodsList(goods);
          setShowGoodsSelect(false);
          setSelectedGoodsIndex(goods.length - 1);
          message.success({ content: `新建客户产品成功 [#${supplier.name_cn}]`, key, duration: 2 });
        }));
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDeleteGoods = (goods) => {
    try {
      const key = 'delete_supplier_goods';
      console.log('onDeleteGoods:', goods);
      checkCanDeleteGoods(supplier.id, goods.goods_id, goods.goods_spec_id).then(data => {
        if (data.length > 0) {
          Modal.error({
            title: '删除错误',
            content: <span>
              <strong>该产品已被下列订单使用，不能删除。</strong><br />
              {
                data.map(x => {
                  return <div><strong>{x.po_code}</strong> - {x.no}</div>
                })
              }
            </span>,
          });
          return;
        }
        message.loading({ content: `正在删除供应商产品 [${goods.goods_name}-${goods.goods_spec_name}]...`, key });
        deleteGoods(supplier.id, goods.goods_id, goods.goods_spec_id).then(() =>
          getGoodsList(supplier.id).then(data => {
            setGoodsList(data);
            if (goodsListItem.length > 0) {
              setSelectedGoodsIndex(0);
            }
            message.success({ content: `删除供应商产品成功 [${goods.goods_name}-${goods.goods_spec_name}]`, key, duration: 2 });
          }));
      });
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const showDeleteConfirm = (index, item) => {
    Modal.confirm({
      title: '确定删除当前产品吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{item.goods_name}-{item.goods_spec_name}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteGoods(item);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onEditPrice = (index) => {
    setSelectedPriceIndex(index);
    setShowPriceEdit(true);
  }

  const onDeletePrice = (index, item) => {
    deleteGoodsPrice(
      item.supplier_id,
      item.goods_id,
      item.goods_spec_id,
      item.start_time
    ).then(data => {

    })
  }

  const onNewPriceCallback = (values) => {
    try {
      const key = 'insert_supplier_goods_price';
      console.log('onNewPriceCallback:', values);
      message.loading({ content: `正在添加产品价格 [${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]...`, key });
      insertGoodsPrice(
        supplier.id,
        selectedGoods.goods_id,
        selectedGoods.goods_spec_id,
        Object.assign({
          start_time: moment(new Date()).format('yyyy-MM-DD HH:mm:ss'),
          end_time: moment(new Date()).format('2099-12-31 23:59:59')
        }, values)

      ).then(() =>
        reloadGoodsPrice().then(() => {
          setShowPriceNew(false);
          message.success({ content: `添加产品价格成功 [${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]`, key, duration: 2 });
        }));
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onBatchEditPriceCallback = (values, callback) => {
    values.forEach((x, i) => {
      try {
        const key = 'edit_buyer_goods_price';
        console.log('onEditPriceCallback:', x);
        message.loading({ content: `正在修改产品价格 [${x.goods_name}-${x.goods_spec_name}]...`, key });
        insertGoodsPrice(
          supplier.id,
          x.goods_id,
          x.goods_spec_id,
          x
        ).then(() => {
          message.success({ content: `修改产品价格成功 [${x.goods_name}-${x.goods_spec_name}]`, key, duration: 2 })
          if (i === values.length - 1) {
            reloadGoodsPrice().then(() => {
              callback && callback();
            })
          }
        });
      } catch (errInfo) {
        console.log('Error:', errInfo);
      }
    })

  }
  const onEditPriceCallback = (values) => {
    const date = moment(new Date()).format('yyyy-MM-DD HH:mm:ss');
    try {
      const key = 'edit_supplier_goods_price';
      console.log('onEditPriceCallback:', values);
      message.loading({ content: `正在修改产品价格 [${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]...`, key });
      insertGoodsPrice(
        supplier.id,
        selectedGoods.goods_id,
        selectedGoods.goods_spec_id,
        Object.assign(
          {
            start_time: date,
            end_time: moment(new Date()).format('2099-12-31 23:59:59')
          }, values)
      ).then(() =>
        reloadGoodsPrice().then(() => {
          setShowPriceEdit(false);
          message.success({ content: `修改产品价格成功 [${selectedGoods.goods_name}-${selectedGoods.goods_spec_name}]`, key, duration: 2 });
        }));
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  // const goodsListItem = (goodsList.map((item, index) => {
  //   return {
  //     ...item,
  //     editable: false,
  //     deletable: authorities.find(x => x === 'create_supplier' || x === 'edit_supplier') || currentUser.category_id === 1
  //   }
  // }));
  const onGoodsSelected = (index) => {
    //const temp = goodsListItem[index];
    //const idx = goodsList.indexOf(goodsList.find(x => x.goods_id === temp.goods_id && x.goods_spec_id === temp.goods_spec_id));
    setSelectedGoodsIndex(index);
  }
  const goodsOptions = [];
  goodsList.forEach(x => {
    if (!goodsOptions.find(y => y.id === x.goods_id)) {
      goodsOptions.push({ id: x.goods_id, name: x.goods_name, prefix: x.prefix });
    }
  });

  const priceListItem = goodsPriceList.map((item, index) => {
    const start_time = moment(item.start_time);
    const end_time = moment(item.end_time)
    return Object.assign(item, {
      default: end_time.diff(moment(new Date()), 'seconds') < 1 ? false : true,
      editable: end_time.diff(moment(new Date()), 'seconds') < 1 ? false : (authorities.find(x => x === 'create_supplier' || x === 'edit_supplier') || currentUser.category_id === 1),
      deletable: start_time.diff(moment(new Date()), 'seconds') < 1 ? false : (authorities.find(x => x === 'create_supplier' || x === 'edit_supplier') || currentUser.category_id === 1),
    })
  });

  const operations = <Button type="primary" onClick={() => setShowBatchPriceEdit(true)} size="small">产品一览&批量修改价格</Button>;
  const symbol = (currency.find(x => x.id === supplier.currency_id) || {}).symbol;
  return (
    <div style={{ padding: '0 1rem' }}>
      <Row>
        <Col span={8}>
          <List
            selectable={true}
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong>产品列表&nbsp;&nbsp;
                  <Select
                    optionFilterProp="children"
                    allowClear
                    showSearch
                    onChange={setFilterGoodsId}
                    style={{ width: '200px' }}
                    size="small">
                    {
                      goodsOptions.map(x => {
                        return <Select.Option value={x.id}>
                          [{x.prefix}] - {x.name}
                        </Select.Option>
                      })
                    }
                  </Select></strong>
                {(authorities.find(x => x === 'create_supplier' || x === 'edit_supplier') || currentUser.category_id === 1) && <Button type="primary" onClick={() => setShowGoodsSelect(true)} icon={<PlusOutlined />} size="small">添加产品</Button>}
              </div>
            }
            emptyContent={<span>暂无产品, 点击<Button onClick={() => setShowGoodsSelect(true)} type="link产品">添加</Button></span>}
            onDelete={showDeleteConfirm}
            footer={<div style={{ textAlign: 'right' }}>共{goodsList.length}项</div>}
            bordered={true}
            rows={goodsListItem}
            renderItem={(item, index) => {
              return <div>[{item.goods_name}]-{item.goods_spec_name}</div>
            }}
            onSelected={onGoodsSelected}
            selected={selectedGoodsIndex}
          />
        </Col>
        <Col span={16} >
          <Tabs style={{ marginLeft: '2rem' }} tabBarExtraContent={operations}>
            <TabPane tab={<span><DollarOutlined />价格体系{currency.find(x => x.id === supplier.currency_id).name}</span>} key="1">
              {
                <List
                  title={null}
                  bordered={true}
                  rows={priceListItem}
                  emptyContent={
                    <div style={{ padding: '6rem', width: '100%', textAlign: 'center' }}>
                      该产品暂无价格,点击
                    <Button onClick={() => setShowPriceNew(true)} style={{ padding: 0 }} type="link">添加价格</Button>
                    </div>}
                  renderItem={(item, index) => {
                    if (!item.default) {
                      return <div style={{ fontSize: '1.25rem' }}>{item.start_time} - {item.end_time}  <span>{symbol}{item.price}/PCS</span> </div>
                    } else {
                      return <div style={{ fontSize: '1.25rem' }}><strong>{item.start_time} - {item.end_time}  <span style={{ color: 'red' }}>{symbol}{item.price}/PCS</span></strong></div>
                    }
                  }}
                  onDelete={onDeletePrice}
                  onEdit={onEditPrice}
                />
              }
            </TabPane>
          </Tabs>
        </Col>
      </Row>
      <Divider style={{ margin: '1rem 0' }} />
      <div className="page-footer">
        <div></div>
        <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>
      </div>
      <Page
        title="产品选择"
        width="1024px"
        onCloseCallback={() => setShowGoodsSelect(!isShowGoodsSelect)}
        body={<GoodsSelect filteredGoods={goodsList} onOk={onGoodsSelect} />}
        visible={isShowGoodsSelect}
      />
      <Page
        title="新建价格"
        width="50vw"
        onCloseCallback={() => setShowPriceNew(!isShowPriceNew)}
        body={<GoodsPriceEdit
          goodsName={selectedGoods.goods_name}
          goodsSpecName={selectedGoods.goods_spec_name}
          onSaveCallback={onNewPriceCallback}
          onClose={() => setShowPriceNew(!isShowPriceNew)}
        />}
        visible={isShowPriceNew}
      />
      <Page
        title="修改价格"
        width="50vw"
        onCloseCallback={() => setShowPriceEdit(!isShowPriceEdit)}
        body={<GoodsPriceEdit
          goodsName={selectedGoods.goods_name}
          goodsSpecName={selectedGoods.goods_spec_name}
          onSaveCallback={onEditPriceCallback}
          price={selectedGoodsPrice.price}
          onClose={() => setShowPriceEdit(!isShowPriceEdit)}
        />}
        visible={isShowPriceEdit}
      />
      <Page
        title={`批量修改价格 [ ${supplier.name} ]`}
        isMaximize={true}
        onCloseCallback={() => setShowBatchPriceEdit(false)}
        body={<GoodsPriceBatchEdit
          goodsCategory={goods_category}
          precision={3}
          getGoodsList={getSupplierGoodsListAndPrice}
          onSaveCallback={onBatchEditPriceCallback}
          onCloseCallback={() => setShowBatchPriceEdit(false)}
        />}
        visible={isShowBatchPriceEdit}
      />
    </div>
  )
});
